import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@onefootprint/ui';
import { useContext } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { type IDV2Store, StoreContext } from '@/idv2/features/idv-to-idv2/idv2-provider';
export const TenantLogo = t0 => {
  const $ = _c(3);
  const {
    orgName,
    logoUrl
  } = t0;
  let t1;
  if ($[0] !== logoUrl || $[1] !== orgName) {
    t1 = <div className="w-fit rounded-full border border-solid border-tertiary"><Avatar name={orgName} size="xlarge" src={logoUrl} /></div>;
    $[0] = logoUrl;
    $[1] = orgName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

/** The tenant's logo for an identify screen's header, when the host asks for it with `showLogo`. */
export const useTenantLogo = () => {
  const $ = _c(4);
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error("useTenantLogo must be used within Idv2Provider");
  }
  const {
    showLogo,
    orgName,
    logoUrl
  } = useStore(store, useShallow(_temp));
  let t0;
  if ($[0] !== logoUrl || $[1] !== orgName || $[2] !== showLogo) {
    t0 = showLogo && orgName ? <TenantLogo orgName={orgName} logoUrl={logoUrl} /> : undefined;
    $[0] = logoUrl;
    $[1] = orgName;
    $[2] = showLogo;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
function _temp(state) {
  return {
    showLogo: state.initialValues.showLogo,
    orgName: state.initialValues.config.orgName,
    logoUrl: state.initialValues.config.logoUrl
  };
}